var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAchievement = function SvgAchievement(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8751 7.87384V3.37384C25.8759 3.02659 25.7964 2.68385 25.6426 2.37247C25.4889 2.06109 25.2652 1.78952 24.989 1.57901C24.7129 1.3685 24.3917 1.22477 24.0507 1.15908C23.7098 1.09339 23.3582 1.10751 23.0236 1.20034L7.27357 5.58034C6.79132 5.73898 6.3718 6.04646 6.07532 6.45857C5.77884 6.87067 5.62068 7.36618 5.62357 7.87384",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 32.6231C5.625 33.2198 5.86205 33.7921 6.28401 34.2141C6.70597 34.636 7.27826 34.8731 7.875 34.8731H28.125C28.7217 34.8731 29.294 34.636 29.716 34.2141C30.1379 33.7921 30.375 33.2198 30.375 32.6231V10.1141C30.375 9.51736 30.1379 8.94506 29.716 8.5231C29.294 8.10115 28.7217 7.86409 28.125 7.86409L5.625 7.87309V32.6231Z",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7964 12.8578L20.6684 16.5433H23.8589C24.0342 16.5398 24.2066 16.5891 24.3535 16.6847C24.5005 16.7804 24.6153 16.918 24.683 17.0797C24.7508 17.2414 24.7684 17.4198 24.7335 17.5916C24.6986 17.7634 24.6129 17.9208 24.4874 18.0433L21.5579 20.9263L23.1809 24.6538C23.252 24.8245 23.2677 25.0131 23.2259 25.1931C23.1841 25.3732 23.0868 25.5356 22.9479 25.6575C22.8089 25.7794 22.6353 25.8546 22.4513 25.8726C22.2673 25.8906 22.0824 25.8505 21.9224 25.7578L17.9999 23.5498L14.0774 25.7548C13.9175 25.8475 13.7325 25.8876 13.5486 25.8696C13.3646 25.8516 13.1909 25.7764 13.052 25.6545C12.913 25.5326 12.8158 25.3702 12.774 25.1901C12.7322 25.0101 12.7479 24.8215 12.8189 24.6508L14.4419 20.9233L11.5124 18.0388C11.387 17.9163 11.3013 17.7589 11.2664 17.5871C11.2315 17.4153 11.2491 17.2369 11.3168 17.0752C11.3846 16.9135 11.4994 16.7759 11.6464 16.6802C11.7933 16.5846 11.9656 16.5353 12.1409 16.5388H15.3314L17.2049 12.8578C17.2814 12.7131 17.3959 12.5919 17.5361 12.5074C17.6764 12.4229 17.837 12.3783 18.0007 12.3783C18.1644 12.3783 18.325 12.4229 18.4652 12.5074C18.6054 12.5919 18.72 12.7131 18.7964 12.8578V12.8578Z",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 30.373H23.625",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAchievement, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/achievement.194dda24.svg";
export { ForwardRef as ReactComponent };